import { render, staticRenderFns } from "./NewDuixiangForm.vue?vue&type=template&id=2f43e971&"
import script from "./NewDuixiangForm.vue?vue&type=script&lang=js&"
export * from "./NewDuixiangForm.vue?vue&type=script&lang=js&"
import style0 from "./NewDuixiangForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewDuixiangForm.vue"
export default component.exports